import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PerFormPrimengModule } from '@lbmx/per-form-primeng';
import { UtilsModule } from '@lbmx/phoenix-lib-utils';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule, ProgressSpinnerModule } from 'primeng-lts';
import { AssignOptionsContainerComponent } from './assign-options-container.component';
import { AssignOptionsComponent } from './assign-options.component';

@NgModule({
  declarations: [AssignOptionsComponent, AssignOptionsContainerComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    PerFormPrimengModule,
    ProgressSpinnerModule,
    ButtonModule,
    UtilsModule,
  ],
  exports: [AssignOptionsContainerComponent],
})
export class AssignOptionsModule {}
